import api from "../../../lib/api";

export default {
  getContentsPageList(data) {
    return api({
      endpoint: "contents-images",
      path: "281B56D6-1A72-4006-8268-1E4FB7AA25D4",
      method: "GET",
      queryParams: data
    });
  }
};
